import { toast, ToastOptions, Id } from "react-toastify";
import { ToastDS, ToastType } from "./Toast";

export const triggerToastDS = (
  text: string,
  type: ToastType,
  options?: ToastOptions,
): Id | undefined => {
  if (type === "SUCCESS")
    return toast.success(<ToastDS text={text} type="SUCCESS" />, options);
  if (type === "ERROR")
    return toast.error(<ToastDS text={text} type="ERROR" />, options);
  if (type === "DOWNLOADING")
    return toast.info(<ToastDS text={text} type="DOWNLOADING" />, options);
  return undefined;
};

export const updateToastDS = (
  toastId: Id,
  text: string,
  type: ToastType,
  progress: number,
) => {
  if (type === "SUCCESS")
    toast.update(toastId, {
      render: <ToastDS text={text} type="SUCCESS" progress={progress} />,
    });
  else if (type === "ERROR")
    toast.update(toastId, {
      render: <ToastDS text={text} type="ERROR" progress={progress} />,
    });
  else if (type === "DOWNLOADING")
    toast.update(toastId, {
      render: <ToastDS text={text} type="DOWNLOADING" progress={progress} />,
    });
};

export const dismissToastDS = (toastId?: Id) => {
  toast.dismiss(toastId);
};
